export default {
      id: "icon-feedback-group-usage",
      viewBox: "0 0 35.28 45",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-feedback-group",
      toString: function () {
        return this.url;
      }
    }